

import axios from "@/plugins/axios.js"

const actions = {
  fetchPlans({ commit, state}, force = false) {
    if(!force && state.data.length) return
    return new Promise((resolve, reject) => {
      axios.get("/plans")
        .then((response) => {
          if(response.data.success){
            commit('SET_PLANS', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
}

const getters = {
}

const mutations = {
  SET_PLANS(state, data){
    state.data = data
  },
  ADD_PLAN(state, item){
    state.data.unshift(item);
  },
  UPDATE_PLAN(state, item){
    const dataIndex = state.data.findIndex((p) => p.id == item.id)
    Object.assign(state.data[dataIndex], item)
  },
  DELETE_PLAN(state, itemId){
    const ItemIndex = state.data.findIndex((item) => item.id == itemId)
    state.data.splice(ItemIndex, 1);
  },
}

const state = {
  data: [],
}

export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

